export default "__VITE_ASSET__B0xadSpy__"